import React from 'react';
import { Link } from 'react-router-dom';

const Privacy = () => {
  return (
    <div className="privacy-page">
      {/* Hero Banner */}
      <section className="py-20 bg-gradient-to-r from-blue-900 via-blue-800 to-blue-900 relative overflow-hidden">
        <div className="absolute inset-0 opacity-20">
          <img 
            src="https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=1920" 
            alt="Privacy Policy" 
            className="w-full h-full object-cover"
          />
        </div>
        <div className="max-w-7xl mx-auto px-4 relative z-10 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            Privacy <span className="text-green-500">Policy</span>
          </h1>
          <p className="text-white text-xl max-w-3xl mx-auto">
            Your privacy is important to us. Learn how we collect, use, and protect your personal information.
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4">
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-600 mb-8">
              plexgate.ca website is owned by Plexgate Inc, which is a data controller of your personal data. We have adopted this Privacy Policy, which determines how we are processing the information collected by plexgate.ca, which also provides the reasons why we must collect certain personal data about you.
            </p>

            <p className="text-gray-600 mb-8">
              Therefore, you must read this Privacy Policy before using plexgate.ca website. We take care of your personal data and undertake to guarantee its confidentiality and security.
            </p>

            {/* Personal Information Section */}
            <div className="mb-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Personal Information We Collect</h2>
              <p className="text-gray-600 mb-4">
                When you visit plexgate.ca, we automatically collect certain information about your device, including information about your web browser, IP address, time zone, and some of the installed cookies on your device.
              </p>
              <p className="text-gray-600 mb-4">
                Additionally, as you browse the Site, we collect information about the individual web pages or products you view, what websites or search terms referred you to the Site, and how you interact with the Site. We refer to this automatically-collected information as "Device Information."
              </p>
              <p className="text-gray-600">
                Moreover, we might collect the personal data you provide to us (including but not limited to Name, Surname, Address, payment information, etc.) during registration to be able to fulfill the agreement.
              </p>
            </div>

            {/* Why We Process Data Section */}
            <div className="mb-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Why Do We Process Your Data?</h2>
              <p className="text-gray-600 mb-4">
                Our top priority is customer data security, and, as such, we may process only minimal user data, only as much as it is absolutely necessary to maintain the website.
              </p>
              <p className="text-gray-600 mb-4">
                Information collected automatically is used only to identify potential cases of abuse and establish statistical information regarding website usage. This statistical information is not otherwise aggregated in such a way that it would identify any particular user of the system.
              </p>
              <p className="text-gray-600">
                You can visit the website without telling us who you are or revealing any information, by which someone could identify you as a specific, identifiable individual. If, however, you wish to use some of the website's features, or you wish to receive our newsletter or provide other details by filling a form, you may provide personal data to us.
              </p>
            </div>

            {/* Your Rights Section */}
            <div className="mb-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Your Rights</h2>
              <p className="text-gray-600 mb-4">
                If you are a European resident, you have the following rights related to your personal data:
              </p>
              <ul className="list-disc pl-6 text-gray-600 mb-4">
                <li>The right to be informed</li>
                <li>The right of access</li>
                <li>The right to rectification</li>
                <li>The right to erasure</li>
                <li>The right to restrict processing</li>
                <li>The right to data portability</li>
                <li>The right to object</li>
                <li>Rights in relation to automated decision-making and profiling</li>
              </ul>
              <p className="text-gray-600">
                If you would like to exercise this right, please contact us through the contact information below.
              </p>
            </div>

            {/* Data Transfer Section */}
            <div className="mb-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">International Data Transfers</h2>
              <p className="text-gray-600">
                Additionally, if you are a European resident, we note that we are processing your information in order to fulfill contracts we might have with you (for example, if you make an order through the Site), or otherwise to pursue our legitimate business interests listed above. Additionally, please note that your information might be transferred outside of Europe, including Canada and the United States.
              </p>
            </div>

            {/* Links to Other Websites Section */}
            <div className="mb-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Links to Other Websites</h2>
              <p className="text-gray-600">
                Our website may contain links to other websites that are not owned or controlled by us. Please be aware that we are not responsible for such other websites or third parties' privacy practices. We encourage you to be aware when you leave our website and read the privacy statements of each website that may collect personal information.
              </p>
            </div>

            {/* Information Security Section */}
            <div className="mb-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Information Security</h2>
              <p className="text-gray-600">
                We secure information you provide on computer servers in a controlled, secure environment, protected from unauthorized access, use, or disclosure. We keep reasonable administrative, technical, and physical safeguards to protect against unauthorized access, use, modification, and personal data disclosure in its control and custody. However, no data transmission over the Internet or wireless network can be guaranteed.
              </p>
            </div>

            {/* Legal Disclosure Section */}
            <div className="mb-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Legal Disclosure</h2>
              <p className="text-gray-600">
                We will disclose any information we collect, use or receive if required or permitted by law, such as to comply with a subpoena or similar legal process, and when we believe in good faith that disclosure is necessary to protect our rights, protect your safety or the safety of others, investigate fraud, or respond to a government request.
              </p>
            </div>

            {/* Cookies Policy Section */}
            <div className="mb-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Cookies Policy</h2>
              <p className="text-gray-600 mb-4">
                We use cookies to enhance your experience on our website. Cookies are small text files that are stored on your device when you visit our website.
              </p>
              <p className="text-gray-600 mb-2">We use cookies for:</p>
              <ul className="list-disc pl-6 text-gray-600 mb-4">
                <li>Essential website functionality</li>
                <li>Analytics and performance monitoring</li>
                <li>Personalization of content</li>
                <li>Marketing and advertising (with your consent)</li>
              </ul>
              <p className="text-gray-600">
                You can control cookie settings through your browser preferences. However, disabling cookies may affect the functionality of our website.
              </p>
            </div>

            {/* Children's Privacy Section */}
            <div className="mb-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Children's Privacy</h2>
              <p className="text-gray-600">
                Our services are not directed to individuals under the age of 13. We do not knowingly collect personal information from children under 13. If you are a parent or guardian and believe your child has provided us with personal information, please contact us immediately.
              </p>
            </div>

            {/* Changes to Privacy Policy Section */}
            <div className="mb-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Changes to This Privacy Policy</h2>
              <p className="text-gray-600">
                We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date at the bottom of this Privacy Policy.
              </p>
            </div>
          </div>

          {/* Contact Section */}
          <div className="mt-12 p-6 bg-gray-50 rounded-lg border-l-4 border-blue-600">
            <h3 className="text-xl font-bold text-gray-900 mb-2">Contact Information</h3>
            <p className="text-gray-600 mb-4">
              If you would like to contact us to understand more about this Policy or wish to contact us concerning any matter relating to individual rights and your Personal Information, you may send an email to:
            </p>
            <a href="mailto:info@plexgate.ca" className="text-blue-600 hover:text-blue-700 font-semibold">
              info@plexgate.ca
            </a>
            <p className="text-gray-600 mt-4">
              Or visit our <Link to="/contact" className="text-blue-600 hover:text-blue-700 font-semibold">Contact Page</Link>
            </p>
          </div>

          {/* Last Updated */}
          <div className="mt-8 text-center text-gray-500 text-sm">
            <p>Last Updated: January 2024</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Privacy;